export type HomeSearchHelpItem = {
  key: string;
  label: string;
  icon: string;
  example: string;
  examples?: string[];
  helpTitle: string;
  helpLines: string[];
  tips: string[];
  sortOrder: number;
  enabled: boolean;
};

export const DEFAULT_HOME_SEARCH_HELP_ITEMS: HomeSearchHelpItem[] = [
  {
    key: 'id_card_completion',
    label: '身份证补齐',
    icon: 'ri-id-card-line',
    example: '李莫愁 230***1990**220784',
    examples: [
      '李莫愁 230***1990**220784',
      '**愁 230229199007220784',
      '李*愁 ******19900722******',
      '李*愁 230229********07****',
    ],
    helpTitle: '身份证补齐（*或#为占位符）',
    helpLines: [
      '方式一: 精准姓名+模糊身份证',
      '李莫愁 230***1990**220784',
      '方式二: 模糊姓名+精准身份证',
      '**愁 230229199007220784',
      '方式三: 双模糊',
      '李*愁 ******19900722******',
      '李*愁 230229********07****',
    ],
    tips: ['需前六+第15 16位或出生年月日不模糊。'],
    sortOrder: 10,
    enabled: true,
  },
  {
    key: 'phone_completion',
    label: '手机号补齐',
    icon: 'ri-smartphone-line',
    example: '李莫愁 15*336****7',
    examples: ['李莫愁 15*336****7', '**愁 15133654657', '李*愁 151****4657'],
    helpTitle: '手机号补齐',
    helpLines: [
      '方式一: 精准姓名+模糊手机',
      '李莫愁 15*336****7',
      '方式二: 模糊姓名+精准手机',
      '**愁 15133654657',
      '方式三: 双模糊',
      '李*愁 151****4657',
    ],
    tips: ['手机号前三后四必填。'],
    sortOrder: 20,
    enabled: true,
  },
  {
    key: 'hunter_query',
    label: '猎魔查询',
    icon: 'ri-sword-line',
    example: '李莫愁 1990 河北石家庄裕华 女',
    examples: ['李莫愁 1990 河北石家庄裕华 女', '李莫愁 20岁左右 河北省石家庄市 女'],
    helpTitle: '猎魔查询',
    helpLines: [
      '1. 普通猎魔',
      '格式：姓名 + 描述（空格分隔）',
      '年龄描述支持:',
      '1990 | 199906 | 19900406',
      '1990-1995 | 1999.03 | 1990.4.6',
      '1990年 | 1990年3月 | 1990年3月2日',
      '1990年左右 | 1990-1999年',
      '20岁 | 20岁左右 | 20-25岁',
      '地区描述支持:',
      '河北省 | 石家庄市 | 裕华区',
      '河北省石家庄市 | 河北省石家庄市裕华区',
      '河北石家庄裕华',
      '自动识别新旧地名，暂不支持镇县',
      '性别描述支持: 男/女',
    ],
    tips: ['姓名和描述请用空格分隔。'],
    sortOrder: 30,
    enabled: true,
  },
  {
    key: 'natural_language_hunter',
    label: '自然语言猎魔',
    icon: 'ri-chat-search-line',
    example: '周立波，1967年4月22日出生，浙江宁波人',
    examples: [
      '周立波，1967年4月22日出生，浙江宁波人',
      '张三，30岁左右，北京海淀人，IT从业者',
    ],
    helpTitle: '自然语言猎魔',
    helpLines: [
      '周立波，1967年4月22日出生，浙江宁波人',
      '张三，30岁左右，北京海淀人，IT从业者',
    ],
    tips: ['查询内容越精确，结果越准确。'],
    sortOrder: 40,
    enabled: true,
  },
];
